import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.5)",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 7.99967,
			cy: 8.00016,
			r: 2.66667,
			fill: "currentColor"
		})
	})
});
export default SvgDotFill;
